import handleDateInput from './handleDateInput';
import handlePhoneInput from './handlePhoneInput';

let isControlPressed = false;

document.addEventListener('keydown', event => {
  if (event.key === 'Control') {
    isControlPressed = true;
  }
});

document.addEventListener('keyup', event => {
  if (event.key === 'Control') {
    isControlPressed = false;
  }
});

function listenerFactory(allowedKeys, callback) {
  return event => {
    if (!event.key) {
      return;
    }
    const isNormalChar = event.key.length === 1;
    if (!isNormalChar) {
      return;
    }
    if (!allowedKeys.test(event.key)) {
      if (!isControlPressed && !event.metaKey) {
        event.preventDefault();
      }
      return;
    }

    if (callback) {
      callback(event);
    }
  };
}

const dateKeydownListener = listenerFactory(/[0-9]/, handleDateInput);
const datePasteListener = (event) => {
  event.preventDefault();
};

function date(element) {
  element.addEventListener('keydown', dateKeydownListener);
  element.addEventListener('paste', datePasteListener);
}
function handleNumberInput(event) {
  const element = event.target;
  const max = parseInt(element.max, 10);
  const value = parseInt(element.value, 10);
  const maxLength = parseInt(element.maxLength, 10);
  if (!Number.isNaN(max) && value > max) {
    if (document.activeElement === element && document.getSelection().toString() === element.value) {
      return; // allow to select text and replace number
    }
    event.preventDefault();
  }

  if (maxLength > 0 && !Number.isNaN(maxLength) && element.value.length >= maxLength) {
    if (document.activeElement === element && document.getSelection().toString() === element.value) {
      return; // allow to select text and replace number
    }
    event.preventDefault();
  }
}
const numberListener = listenerFactory(/[0-9]/, handleNumberInput);
function number(element) {
  element.addEventListener('keydown', numberListener);
}

const phoneListener = listenerFactory(/[0-9+\s()]/, handlePhoneInput);
function phone(element) {
  element.addEventListener('keydown', phoneListener);
}

function removeDate(element) {
  element.removeEventListener('keydown', dateKeydownListener);
  element.removeEventListener('paste', datePasteListener);
}

function removeNumber(element) {
  element.removeEventListener('keydown', numberListener);
}

function removePhone(element) {
  element.removeEventListener('keydown', phoneListener);
}

export default {
  date,
  number,
  phone,
  removeDate,
  removeNumber,
  removePhone,
};
